import React, {ReactDOM, ReactNode} from "react";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import FunctionsIcon from '@mui/icons-material/Functions';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import StorefrontIcon from '@mui/icons-material/Storefront';
import WalletIcon from '@mui/icons-material/Wallet';

const tryFormatMoney = (number: number | string = '', force: boolean = false) => {

    if(!(typeof number === 'number') && !force) {
        return 'R$ ' + number;
    }

    return Number(number).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
}

const isEmpty = (value: any): boolean => {
    if (value === null || value === undefined || value === false) {
        return true;
    }
    if (typeof value === "number" && value === 0) {
        return true;
    }
    if (typeof value === "string" && (value.trim() === "" || parseFloat(value) === 0)) {
        return true;
    }
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (typeof value === "object" && Object.keys(value).length === 0) {
        return true;
    }
    return false;
}

const formatDate = (params: any, defaultValue: any = '') => {
    if(params === null || params === undefined || params === '') {
        return defaultValue;
    }

    const value = (params?.value === null || params?.value === undefined)? params : params.value;

    const result = new Date(value).toLocaleString('pt-BR');

    if(result === 'Invalid Date') {
        return defaultValue;
    }

    return result;
}

const handleEmptyName = (params: any, defaultData: any = '') => {
    return params?.value?.name || defaultData;
}

const handleMonetaryValue = (params: any, defaultData: any = 0) => {
    return parseFloat(params?.value || defaultData).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    })
}

const toUppercase = (params: any) =>  {
    return ((params?.value).toUpperCase());
}

const maskEmail = (email: string): string =>  {
    const [localPart = '', domain = ''] = email.split('@');
    const visibleLength = Math.min(3, localPart.length); // Mostra até 3 caracteres no início
    const maskedPart = '*'.repeat(localPart.length - visibleLength);
    return `${localPart.slice(0, visibleLength)}${maskedPart}@${domain}`;
}

const generateRandomString = (length: number): string => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}

const waitMilliseconds = (milliseconds: number): Promise<any> => {
    return new Promise((resolve, reject) => setTimeout(() => resolve(''), milliseconds));
}

const parseCurrency = (value: string): number => {
    return parseFloat(value.trim().replaceAll('.', '').replace(',', '.'));
}

/**
 * Extrai um valor numérico de forma segura de um objeto aninhado
 * @param obj - O objeto que contém o valor
 * @param path - O caminho para acessar o valor (ex: 'icms_totais.vl_icms_recolher')
 * @param defaultValue - Valor padrão a ser retornado se o valor não for um número (padrão: 0)
 * @returns O valor numérico ou o valor padrão
 */
const getSafeNumber = (obj: any, path: string, defaultValue: number = 0): number => {
    const keys = path.split('.');
    let value = obj;
    
    for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
            value = value[key];
        } else {
            return defaultValue;
        }
    }
    
    return typeof value === 'number' ? value : defaultValue;
}

export {
    tryFormatMoney,
    isEmpty,
    formatDate,
    handleEmptyName,
    handleMonetaryValue,
    maskEmail,
    generateRandomString,
    waitMilliseconds,
    parseCurrency,
    toUppercase,
    getSafeNumber
}